import React, { useState, useEffect } from 'react';
import { ArrowUp } from 'lucide-react';

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <>
      <style>{`
        .scroll-to-top {
          position: fixed;
          bottom: 30px;
          left: 30px;
          background: linear-gradient(135deg, #333 0%, #1a1a1a 100%);
          color: white;
          width: 56px;
          height: 56px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
          z-index: 998;
          transition: all 0.3s ease;
          border: none;
          opacity: 0;
          visibility: hidden;
          transform: translateY(20px);
        }

        .scroll-to-top.visible {
          opacity: 1;
          visibility: visible;
          transform: translateY(0);
        }

        .scroll-to-top:hover {
          background: linear-gradient(135deg, #ff6b35 0%, #ff8c42 100%);
          transform: translateY(-6px);
          box-shadow: 0 10px 32px rgba(255, 107, 53, 0.4);
        }

        @media (max-width: 768px) {
          .scroll-to-top {
            width: 46px;
            height: 46px;
            bottom: 20px;
            left: 20px;
          }
        }
      `}</style>

      <button
        className={`scroll-to-top ${isVisible ? 'visible' : ''}`}
        onClick={scrollToTop}
        aria-label="Scroll to top"
      >
        <ArrowUp size={24} />
      </button>
    </>
  );
};

export default ScrollToTop;